/* eslint-disable jsx-a11y/media-has-caption */
import React, { useRef, useEffect } from "react";
import videoSrc from "images/boost/boost-small-business-video.mp4";

const BoostVideo = () => {
  const videoEl = useRef(null);

  useEffect(() => {
    if (videoEl && videoEl.current) {
      videoEl.current.play().catch((error) => {
        console.error("Error attempting to play", error);
      });
    }
  }, []);

  return (
    <video
      src={videoSrc}
      autoPlay
      muted
      playsInline
      style={{
        objectFit: "cover",
        display: "block",
      }}
      ref={videoEl}
    />
  );
};

export default BoostVideo;
